module.exports = __webpack_public_path__ + "img/178.vegetarian.d2965896.svg";